<template>
  <div class="pwa-instruction">
    <h1>Instalowanie aplikacji</h1>

    <div v-if="isIos()">
      <ol>
        <li>
          <p>
            Będąc na stronie głównej strony internetowej, na dolnym pasku wybieramy przycisk
            <strong>„udostępnianie”</strong>.
          </p>

          <img src="/img/pwa-ios-1.png" />
        </li>

        <li>
          <p>2. Po wyświetleniu listy wybieramy opcję <strong>„Do ekranu początkowego”.</strong></p>

          <img src="/img/pwa-ios-2.png" />
        </li>

        <li>
          <p>Wyświetlone zostanie nam okno, w którym klikamy opcję <strong>„Dodaj”</strong>.</p>

          <img src="/img/pwa-ios-3.png" />
        </li>

        <li>
          <p>Skrót do aplikacji znajdziemy w <strong>menu aplikacji</strong>.</p>

          <img src="/img/pwa-ios-4.png" />
        </li>
      </ol>
    </div>

    <div v-else>
      <ol>
        <li>
          <p>
            Będąc na stronie głównej strony internetowej, w prawym górnym rogu wybieramy
            <strong>„więcej opcji”</strong>.
          </p>

          <img src="/img/pwa-android-1.jpg" />
        </li>

        <li>
          <p>2. Po wyświetleniu listy wybieramy opcję <strong>„Dodaj do ekranu głównego”.</strong></p>

          <img src="/img/pwa-android-2.jpg" />
        </li>

        <li>
          <p>Wyświetlone zostanie nam okno, w którym klikamy opcję <strong>„Dodaj”</strong>.</p>

          <img src="/img/pwa-android-3.jpg" />
        </li>

        <li>
          <p>Skrót do aplikacji znajdziemy w <strong>menu aplikacji</strong>.</p>

          <img src="/img/pwa-android-4.jpg" />
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
import { isIos } from '@/utils/regex';

// @vuese
// Instrukcja instalowania aplikacji
// @group views
export default {
  methods: { isIos }
};
</script>

<style>
.pwa-instruction img {
  max-width: 100%;
}
</style>
